import { z } from 'zod';

/** The AI usage report's filters (XT-1002): a period and the doors to count. */

export const AGENT_USAGE_DOORS = [
  'planner',
  'external',
  'draft',
  'runtime',
] as const;

export type AgentUsageDoor = (typeof AGENT_USAGE_DOORS)[number];

export const agentUsageDoorSchema = z.enum(AGENT_USAGE_DOORS);

/** A calendar day, `YYYY-MM-DD`, read as UTC. */
const daySchema = z.iso.date();

/** The longest period one report covers. */
export const AGENT_USAGE_MAX_DAYS = 366;

export const agentUsageInputSchema = z
  .object({
    /** First day, inclusive. */
    from: daySchema,
    /** Last day, inclusive. */
    to: daySchema,
    doors: z
      .array(agentUsageDoorSchema)
      .max(AGENT_USAGE_DOORS.length)
      .optional(),
    /** Count test sessions too (development, test runs, test accounts). */
    includeTests: z.boolean().optional(),
  })
  .refine((v) => v.from <= v.to, {
    message: 'The period ends before it starts',
    path: ['to'],
  })
  .refine(
    (v) =>
      (Date.parse(`${v.to}T00:00:00Z`) - Date.parse(`${v.from}T00:00:00Z`)) /
        86_400_000 <
      AGENT_USAGE_MAX_DAYS,
    { message: 'A report covers at most a year', path: ['from'] }
  );

export type AgentUsageInput = z.infer<typeof agentUsageInputSchema>;
